import React from "react";
import { Box, Typography } from "@mui/material";
import { SparklesIcon } from "@ippon/shared-assets";
import { colors } from "../theme/colors";

interface Props {
  /** "AI" 表示の代わりに任意ラベル ("3件をAIが入力" 等) */
  label?: string;
  /** 親要素 sx へ追加スタイル */
  className?: string;
}

/**
 * AI が自動入力したことを示す視覚バッジ。
 * 参考実装 (b_CLz3pGgI0dl) と同じ Sparkles + "AI" の組み合わせ。
 * 配色は project の primary (cyan) を使用。
 *
 * 使用例:
 *   <AiBadge />              // "AI" だけ
 *   <AiBadge label="3件をAIが入力" />
 */
const AiBadge: React.FC<Props> = ({ label = "AI" }) => {
  return (
    <Box
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        gap: "4px",
        height: "20px",
        px: "6px",
        borderRadius: "10px",
        border: `1px solid ${colors.primary.main}`,
        backgroundColor: colors.background.selected,
        color: colors.primary.main,
        verticalAlign: "middle",
        flexShrink: 0,
      }}
    >
      <SparklesIcon />
      <Typography
        component="span"
        sx={{
          fontSize: 10,
          fontWeight: 600,
          lineHeight: 1,
          color: "inherit",
        }}
      >
        {label}
      </Typography>
    </Box>
  );
};

export default AiBadge;
